











































import {Component} from '@/shared/component';
import {AbstractEditVue} from '@/components/Abstract/AbstractEditVue';
import {LongueursAchat} from '@/models';

import storeLongueursAchat from '@/stores/modules/longueursAchat';

import InputDatePicker from '@/components/Input/DatePicker.vue';
import CrudFournisseurSearch from '@/components/Crud/Fournisseur/Search.vue';

@Component({
	components: {
		InputDatePicker,
		CrudFournisseurSearch,
	}
})
export default class CrudLongueursAchatEdit extends AbstractEditVue<LongueursAchat> {
	public constructor() {
		super(
			storeLongueursAchat,
			'Type de longueur modifié',
			'Type de longueur créé',
		);
	}
}
